import React from "react";
import ReactDOM from "react-dom/client";
// Self-hosted brand fonts (pinned @fontsource packages; no requests to Google Fonts).
import "@fontsource/space-grotesk/500.css";
import "@fontsource/space-grotesk/700.css";
import "@fontsource/ibm-plex-sans/400.css";
import "@fontsource/ibm-plex-sans/500.css";
import "@fontsource/ibm-plex-sans/600.css";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/500.css";
import "@/index.css";
import "@/brand/brand.css";
import { applyStoredTheme } from "@/lib/theme";
import App from "@/App";

applyStoredTheme();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
